<!--
  @component
  Generates canvas dots onto a map using [d3-geo](https://github.com/d3/d3-geo).
 -->
<script>
		import { getContext } from "svelte";
	import { fade } from "svelte/transition";
	import { elasticInOut } from "svelte/easing";
	import { tweened } from "svelte/motion";
	import { cubicOut } from "svelte/easing";

	export let r;
	export let visible;
	export let cx;
	export let cy;
	export let highlighted;
	export let annotated;
	export let showHighlights;
	export let color;
	export let highlightColor;
	export let radiusFactor = 1;
	export let noHighlightOpacity = 0.5;
	export let greyedOut;
	export let tranistionIn = fade;
	export let noPositionTweening;

	const { width } = getContext("LayerCake");

	const annotationColor = '#F3F3F3';
	const mobileAnnotationOffset = -40;
	const strokeWidth = 1;
	const greyedOutColor = "#808080";
	const greyedOutHighlightColor = "#D9D9D9";

	$: tweenParameters = {
			duration: noPositionTweening ? 0 : 400,
			easing: cubicOut,
	};


	const tR = tweened(r, {
		duration: 700,
		easing: cubicOut,
	});
	// const tX = tweened(cx, tweenParameters);
 // const tY = tweened(cy, tweenParameters);


	$: $tR = r;
	// $: tX.set(cx, tweenParameters);
 // $: tY.set(cy, tweenParameters);


	$: fill = !!annotated && !isMobile ? annotationColor : (
		showHighlights && highlighted
			? greyedOut
				? greyedOutHighlightColor
				: highlightColor
			: greyedOut
			? greyedOutColor
			: color
	);
		
	$: fillOpacity = showHighlights ? (highlighted ? .7 : noHighlightOpacity) : .7;

	let annotationParts;

	$: if (!!annotated) {
		annotationParts = annotated.label.split('/n')
	}

	$: isMobile = $width < 400; 
	
</script>

{#if visible}
	<circle
		in:tranistionIn
		on:mouseover
		out:fade
		cx={cx}
		cy={cy}
		r={$tR}
		{fill}
		fill-opacity={fillOpacity}
		stroke={fill}
		stroke-width={strokeWidth}
	/>
	{#if !!annotated && !isMobile}
		<g transition:fade>
			{#if annotated.align === 'center'}
				<line x1={cx} y1={cy} x2={cx} y2={cy + annotated.offset.y + 10} stroke={annotationColor} />
			{:else}
				<line x1={cx} y1={cy} x2={cx + (isMobile ? mobileAnnotationOffset : annotated.offset.x) + 10} y2={cy} stroke={annotationColor} />
			{/if}
				{#each annotationParts as part, i}
				<text
					style:font-weight={i === 0 ? '500' : 'normal'}
					style:text-anchor={annotated.align === 'center' ? 'middle' : 'end'}
					x={cx + (isMobile ? mobileAnnotationOffset : annotated.offset.x)}
					y={annotated.align === 'center' ? (cy + annotated.offset.y + 30) : (cy + annotated.offset.y + i*14)}
					fill={annotationColor}
					class="annotation"
				>
					{part}
				</text>
			{/each}
		</g>
	{/if}
	<!-- <circle
		in:customTransition
		on:mouseover
		out:fade
		cx={$tCx}
		cy={$tCy}
		r={$tR}
		{fill}
		{stroke}
		stroke-width={strokeWidth}
	/> -->
{/if}

<style lang="scss">
	circle {
		transition: fill-opacity 0.3s ease-in-out, fill 0.3s ease-in-out;
	}

	.annotation {
		text-transform: uppercase;
		font-size: 12px;
	}
</style>
